var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.285156,
    y: 0.108398,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9492 25.4769L16.9741 18.0163L12.0823 10.74H14.7021L18.2943 16.2049L21.8659 10.74H24.496L19.6042 18.0163L24.6188 25.4769H21.999L18.2943 19.838L14.5793 25.4769H11.9492Z",
    fill: "#5926F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseW);
export default __webpack_public_path__ + "static/media/close_w.3cc0c610f4ce683cf2af350a11ce4ed1.svg";
export { ForwardRef as ReactComponent };